import API_ROOT from '../../constants/api';
import RoleService from '../RoleService';

export const headers = (token = null) => {
  const header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  return header;
};

export const getBackOfficeRoute = (role) => {
  return `${API_ROOT}/${RoleService.getRoleString(role)}`
}

export default headers;



// WEBPACK FOOTER //
// ./src/services/api/header.js